import { httpClient } from '@/api/http-client';
import type {
  AuditLogControllerGetByEntityData,
  PaginationAuditLogPaginationMeta,
} from '@carvia/ros-client-types';

export type FindAllAuditLogsForEntityDto = AuditLogControllerGetByEntityData['path'] &
  NonNullable<AuditLogControllerGetByEntityData['query']>;

class AuditLogService {
  httpClient = httpClient;
  endpoint = '/audit-log/';

  async getForEntity({ entityType, entityId, page, operation }: FindAllAuditLogsForEntityDto) {
    const res = await this.httpClient.get<PaginationAuditLogPaginationMeta>(
      `${this.endpoint}entity/${entityType}/${entityId}`,
      { params: { page, operation } },
    );
    return res.data;
  }
}

export const auditLogService = new AuditLogService();
